<template>
    <div class="review-order">

      <el-tabs type="border-card" style="box-shadow: none;border-left: none;border-right: none" v-model="activeName">
        <el-tab-pane label="已收到社保代缴申请" name="order">
          <div>
            <div class="btn-group">
              <el-button type="primary" size="mini" @click="exportSocialSecurity">导出</el-button>
            </div>

            <el-table
              size="mini"
              :data="orderTableData"
              :stripe="true"
              border
              style="width: 100%">
              <el-table-column
                type="selection"
                width="40">
              </el-table-column>
              <el-table-column
                prop="applyName"
                label="申请人姓名"
                width="auto">
              </el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
                width="auto">
                <template slot-scope="scope">
                  <span>{{scope.row.createDate | dateFormat("YYYY-MM-DD HH:mm:ss")}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="city"
                label="缴纳城市"
                width="auto">
              </el-table-column>
              <el-table-column
                prop="cardinality"
                label="参保基数"
                width="auto">
              </el-table-column>
              <el-table-column
                prop="feePackage"
                label="参保套餐"
                :show-overflow-tooltip="true"
                width="auto">
              </el-table-column>
              <el-table-column
                prop="securityDate"
                label="初始参保月份"
                width="auto">
              </el-table-column>
              <el-table-column
                prop="securityPrice"
                label="社保单价"
                width="auto">
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="创建时间"
                width="auto">
              </el-table-column>
              <el-table-column
                prop="countMoney"
                label="总金额"
                width="auto">
              </el-table-column>
              <el-table-column
                prop="payStatus"
                label="支付状态"
                width="auto">
              </el-table-column>
            </el-table>

            <div style="padding: 10px 0; text-align: right">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.pageNum"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="page.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="社保代缴套餐管理" name="feepakage">
          <div>
            <div v-for="item of feePackage" :key="item.id" style="margin: 10px 0">
              <span style="display: inline-block;width: 95px;">{{item.title}}:</span>
              <el-input size="mini" v-model="item.money" style="width: 100px"></el-input>
              <span>/月</span>
            </div>

            <div class="btn-group">
              <el-button size="mini" type="primary" @click="saveFeePackage">保存</el-button>
              <el-button size="mini" type="primary" @click="initGetFeePackage">取消</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
import utilService from '../../utils/utilService'

export default {
  name: 'ReceiveOrder',
  data () {
    return {
      activeName: 'order',
      orderTableData: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      feePackage: []
    }
  },
  methods: {
    initData () {
      this.$http.post(this.$api.getListSocialSecurity.url).then(_ => {
        if (_ && _.code === 200) {
          this.orderTableData = _.data || []
        }
      })
    },
    exportSocialSecurity () {
      // this.$http.get(this.$api.exportSocialSecurityOrder.url, null, {
      //   responseType: 'arrayBuffer'
      // }).then(_ => {
      //   let time = new Date().getTime()
      //   utilService.downloadFileForStream(_, `收到的社保代缴申请_${time}.xlsx`, 'application/vnd.ms-excel')
      // })

      let time = new Date().getTime()
      utilService.downLoadFile(this.$api.exportSocialSecurityOrder.url, `收到的社保代缴申请_${time}.xlsx`)
    },
    handleCurrentChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    handleSizeChange (e) {
      this.page.pageSize = e
      this.initData()
    },
    initGetFeePackage () {
      this.$http.get(this.$api.getAllActivityPackage.url).then(_ => {
        if (_ && _.code === 200 && _.data.length > 0) {
          this.feePackage = _.data.map(item => {
            return {
              id: item.id,
              title: item.servicePeriod,
              money: (item.price / 100).toFixed(2)
            }
          }).reverse()
        }
      })
    },
    saveFeePackage () {
      // this.$http.post(this.$api.saveActivityPackage.url, {}).then(_ => {
      //   if (_ && _.code === 200) {
      //     this.$message.success('修改成功！')
      //     this.initGetFeePackage()
      //   }
      // })
    }
  },
  created () {
    this.initData()
    this.initGetFeePackage()
  }
}
</script>

<style scoped>
  .review-order {
    width: 1200px;
    margin: auto;
    text-align: left;
  }
  .btn-group {
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReceiveOrder/ReceiveOrder.vue